module.exports = __webpack_public_path__ + "resources/img/img_magic_eam_m_en.f778b90a139bcc38a304110eedb4a510.png";